export enum PreneedContractType {
    NotApplicable = 'NotApplicable',
    Insurance = 'Insurance',
    Trust = 'Trust',
}
